import { render, staticRenderFns } from "./AgentIcon.vue?vue&type=template&id=42a050c0&scoped=true"
import script from "./AgentIcon.vue?vue&type=script&lang=js"
export * from "./AgentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a050c0",
  null
  
)

export default component.exports